import { primaryPrivateV2Api } from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getNotificationsQueryKey,
  NotificationChannel,
  NotificationsSettings,
} from './get-notifications-settings';
import { usePrivy } from '@privy-io/react-auth';
import { getPrivyPrimaryAddress } from '@/hooks';

type Body = Pick<NotificationChannel, 'channelId'>;

async function deleteChannel(body: Body) {
  return primaryPrivateV2Api.delete('/v2/notifications/channel', {
    data: body,
  });
}

export default function useDeleteChannel() {
  const { user } = usePrivy();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: Body) => deleteChannel(body),
    onSuccess: (_, variables) => {
      const address = getPrivyPrimaryAddress(user);
      queryClient.setQueryData(
        getNotificationsQueryKey(address),
        (prev?: NotificationsSettings) => {
          if (!prev) return prev;
          return {
            ...prev,
            channels: prev.channels.filter(
              (channel) => channel.channelId !== variables.channelId,
            ),
          } as NotificationsSettings;
        },
      );
    },
  });
}
